import i18next from "i18next";

const getLanguage = () => i18next.language || window.localStorage.i18nextLng;

export default getLanguage;
